<div class="flex flex-col items-center composable-wrapper max-width-lg pb-130">
  <app-breadcrumb class="mt-16 pl-30" [items]="breadcrumbItems"></app-breadcrumb>
  <div class="flex flex-col max-width-lg-0">
    <div class="flex flex-row justify-between items-center ml-50">
      <div>
        <div class="flex flex-row mat-headline-3 m-0 fw-500 white-space">
          {{"COMPOSABLE_BANKING.SEE_COMPOSABLE_BANKING_IN_ACTION" | transloco}}
        </div>
        <div class="flex flex-row mat-body-2 mt-22 white-space">
          {{"COMPOSABLE_BANKING.COMPOSE_FROM_THE_BROADEST" | transloco}}
        </div>
        <div class="flex flex-row mt-36">
          <button *ngIf="permissionsMap[PermissionKeys.BLUEPRINT_CREATE]" class="flex justify-start items-center mossgreen" (click)="goToComposeService()">
            <mat-icon svgIcon="add" class="icon-sm mr-10"></mat-icon>{{"COMPOSABLE_BANKING.COMPOSE_A_SERVICE" | transloco}}
          </button>
        </div>
      </div>
      <div (click)="openVideo()" class="cursor-pointer">
        <img src="/assets/images/Composable-Banner-Video.svg">
      </div>
    </div>
  </div>
</div>
<div class="flex flex-col items-center max-width-lg mt-64 mb-70">
  <div class="stepper-wrapper mat-headline-4 ta-center h-72 mb-40">
    {{"COMPOSABLE_BANKING.IN_THREE_EASY_STEPS" | transloco}}
  </div>
  <div class="flex flex-col items-center">
    <div class="md-stepper-horizontal primary">
      <div class="md-step active p-24 w-200">
        <div class="flex justify-center items-center md-step-circle mat-subtitle-2 w-102 h-102 ta-center">1</div>
        <div class="mat-subtitle-2 fw-500 mt-26 ta-center">
          {{"COMPOSABLE_BANKING.DISCOVER_TEMENOS_OFFERING" | transloco}}
        </div>
        <div class="md-step-bar-left mr-50"></div>
        <div class="md-step-bar-right ml-50"></div>
      </div>
      <div class="md-step active p-24 w-200">
        <div class="flex justify-center items-center md-step-circle mat-subtitle-2 w-102 h-102 ta-center">2</div>
        <div class="mat-subtitle-2 fw-500 mt-26 ta-center">
          {{"COMPOSABLE_BANKING.CHOOSE_THE_OPTION" | transloco}}
        </div>
        <div class="md-step-bar-left mr-50"></div>
        <div class="md-step-bar-right ml-50"></div>
      </div>
      <div class="md-step active p-24 w-200">
        <div class="flex justify-center items-center md-step-circle mat-subtitle-2 w-102 h-102 ta-center">3</div>
        <div class="mat-subtitle-2 fw-500 mt-26 ta-center">
          {{"COMPOSABLE_BANKING.SERVICE_BUILDER" | transloco}}
        </div>
        <div class="md-step-bar-left mr-50"></div>
        <div class="md-step-bar-right ml-50"></div>
      </div>
    </div>
  </div>
</div>
<app-new-line-of-business></app-new-line-of-business>
